import { Store } from 'Vuex'

export default class NetworkConnectionManager {
    store: Store<any>
    mutationOnline: string
    mutationOffline: string
    
    constructor(store: Store<any>, mutationOnline: string, mutationOffline: string) {
        this.store = store
        this.mutationOnline = mutationOnline
        this.mutationOffline = mutationOffline

        window.addEventListener('online', this.connectionStateChange)
        window.addEventListener('offline', this.connectionStateChange)

        this.connectionStateChange()
    }

    connectionStateChange = () => {
        if (navigator.onLine) {
            // console.log ('CSC - online', this.store)
            this.store.commit(this.mutationOnline)
        } else {
            // console.log ('CSC - offline', this.store)
            this.store.commit(this.mutationOffline)
        }
    }
}